import { useParams } from 'react-router-dom';
import { useUserlistResourcesQuery } from 'redux/reducers/assignmentEvalutaion';
import { backendURL } from 'redux/reducers/settings';

const UserResourcesList = () => {
  const { training_id } = useParams<{ training_id: string }>();
  const routineId = Number(training_id || 0);

  const { data, error, isLoading } = useUserlistResourcesQuery(routineId);

  if (isLoading) {
    return <div className="text-center mt-4">Loading...</div>;
  }

  if (error) {
    return <div className="alert alert-danger mt-4">Failed to load resources</div>;
  }

  if (!data) return null;

  return (
    <div className="container mt-4">
      <div className="card mb-4 shadow-sm">
        <div className="card-body">
          <h5 className="card-title">{data?.training_name || ''}</h5>
          <p className="text-muted mb-1">
            <strong>Training Code:</strong> {data?.training_code || ''}
          </p>
        </div>
      </div>

      <div className="card shadow-sm">
        <div className="card-header">
          <strong>Resources</strong>
        </div>

        <ul className="list-group list-group-flush">
          {data?.resources?.length > 0 ? (
            data?.resources?.map((res: any) => (
              <li
                key={res.id}
                className="list-group-item d-flex justify-content-between align-items-center">
                <span>{res.name}</span>

                <a
                  href={`${backendURL}${res.resource_file}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-sm btn-primary">
                  Open
                </a>
              </li>
            ))
          ) : (
            <li className="list-group-item text-muted text-center">No resources available</li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default UserResourcesList;
